export const defaultScrollBarProps = {
  width: "7px",
  trackBackgroundColor: "#f1f1f1",
  thumbBackgroundColor: "#888",
  thumbBorderRadius: "10px",
  thumbHoverColor: "#555"
};